import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../../actions/fillCombo_action';
import { cityActionId, stallTypeActionId, stallListActionId, accountTypeMasterListActionId, promoCodeUtilizationActionId, countryActionId, exhibitionActionId, hallMasterListActionId, toastError, toastSuccess, exhibitionId } from "../../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Pagination from "../../../../../utils/pagination";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import {
    getPromoCodeList_action,
    deletePromoCode_action,
    insertPromoCode_action,
    updatePromoCode_action, getPromoCodeDetails_action
} from "../../../../../actions/admin_module_action/master_action/exhibition_master_action/promocode_master_action";
import Footer from "../../../../../common_components/Footer";


class Exh_promoCode extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            currentPage: 1,
            exhibitionList: [],
            hallMasterList: [],
            stallMasterList: [],
            exhibitionID: '',
            hallID: '',
            stallName: '',
            deleteID: '',

            accountTypeList: [],
            promocodeList: [],
            CouponCode: '',
            disPer: '',
            expiry: '',
            status: '',
            accountTypeId: '',
            NOC: '',
            isAu: false,

            CouponCodeAU: '',
            disPerAU: '',
            expiryAU: '',
            statusAU: '',
            accountTypeIdAU: '',
            NOCAU: '',
            exhibitionIDAU: '',
            isAUid: '',
            Utilization: '',
            utilizationList: []
        }

        this.getFillList = this.getFillList.bind(this)
        this.record = this.record.bind(this)
        this.updateItem = this.updateItem.bind(this)
        this.clearSearch = this.clearSearch.bind(this)
        this.deleteprmocodeMaster = this.deleteprmocodeMaster.bind(this)
        // this.handleAdd = this.handleAdd.bind(this)
        // this.handleUpdate = this.handleUpdate.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.getpromocodeMasterList = this.getpromocodeMasterList.bind(this)
        this.onExhibitionChange = this.onExhibitionChange.bind(this)
        this.insertPromocodeMaster = this.insertPromocodeMaster.bind(this)
        this.updatePromoCodeMaster = this.updatePromoCodeMaster.bind(this)
        this.getPromocodeMasterDetails = this.getPromocodeMasterDetails.bind(this)
        this.maxLengthCheck = this.maxLengthCheck.bind(this)

    }

    componentDidMount() {
        this.getFillList(exhibitionActionId, '', '', '', '', '');
        this.getFillList(accountTypeMasterListActionId, '', '', '', '', '');
        this.getFillList(promoCodeUtilizationActionId, '', '', '', '', '');
        console.log("here")
        this.getpromocodeMasterList()
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // country list
                    if (actionID === exhibitionActionId) {
                        console.log("country data", data.data)
                        // var internationalCountryData = data.data.length > 0 && data.data.filter((item) => item.Code != "91")
                        this.setState({
                            exhibitionList: data.data
                        })

                    }
                }
                if (data.error != 1) {
                    // country list
                    if (actionID === accountTypeMasterListActionId) {
                        console.log("country data", data.data)
                        // var internationalCountryData = data.data.length > 0 && data.data.filter((item) => item.Code != "91")
                        this.setState({
                            accountTypeList: data.data
                        })

                    }
                }
                if (data.error != 1) {
                    // country list
                    if (actionID === promoCodeUtilizationActionId) {
                        console.log("country data", data.data)
                        // var internationalCountryData = data.data.length > 0 && data.data.filter((item) => item.Code != "91")
                        this.setState({
                            utilizationList: data.data
                        })

                    }
                }
                this.setState({ isLoading: false })
            })
            .catch((e) => {
                console.log(e);
            });
    }

    record(list) {
        return (
            <table className="table border text-nowrap mx-2 text-md-nowrap table-bordered mb-0">
                <thead>
                    <tr>
                        {/* <th className="text-center">Role ID</th> */}
                        {/* <th className="text-center">From Date</th>
                        <th className="text-center">To Date</th>
                    <th className="text-center">Country</th> */}
                        <th style={{ width: '50px' }} className="text-center"></th>
                        <th className="text-center">Coupon Code</th>
                        <th className="text-center">Account Type</th>
                        <th className="text-center">Discount Percent</th>
                        <th className="text-center">Expiry Date</th>
                        <th className="text-center">No of Coupons</th>
                        <th style={{ width: '60px' }} className="text-center"></th>
                        <th style={{ width: '60px' }} className="text-center"></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr key={Math.random()}>
                                    <td className="text-center" style={{ width: '50px' }}>{i + 1}</td>
                                    {/* <td className="text-center">{data.RoleID}</td> */}
                                    {/* <td className="text-center">{moment(data.ExhibitionDateFrom).format('L')}</td>
                                    <td className="text-center">{moment(data.ExhibitionDateTo).format('L')}</td>
                                <td className="text-center">{this.state.countryList.map(id => (parseInt(id.Code) == data.CountryID ? id.Description : null))}</td> */}
                                    <td className="text-center">{data.Code}</td>
                                    <td className="text-center">{data.AccountType}</td>
                                    <td className="text-center">{data.DiscountPercent}%</td>
                                    <td className="text-center">{moment(data.ExpiryDate).format('DD/MM/YYYY')}</td>
                                    <td className="text-center">{data.NoofCoupens}</td>
                                    <td className="text-center">
                                        <button
                                            type="button"
                                            className="btn btn-aqua"
                                            onClick={e => this.setState({
                                                isAu: true, isAUid: data.PromoCodeID
                                            }, () => this.getPromocodeMasterDetails())}
                                        >
                                            Update
                                        </button>
                                    </td>
                                    <td className="text-center">
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={(e) => this.onDelete(data.PromoCodeID)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }
                </tbody>
            </table>)
    }

    getpromocodeMasterList() {
        this.setState({ isLoading: true })
        const { CouponCode, disPer, expiry, status } = this.state
        this.props.getPromoCodeList_action(CouponCode, disPer, expiry != null && expiry != '' ? moment(expiry).format('YYYY-MM-DD') : '', 1)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data[0])
                    this.setState({ promocodeList: data.data })
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    clearSearch() {
        const { exhibitionID, hallName } = this.state
        this.setState({
            isAu: false, isAUid: '', exhibitionIDAU: '',
            accountTypeIdAU: '',
            // CouponCodeAU: '',
            disPerAU: '',
            expiryAU: '',
            NOCAU: '',

            CouponCode: '',
            disPer: '',
            expiry: ''
        })
        setTimeout(() => {
            this.getpromocodeMasterList()
        }, 100);
    }

    // handleAdd() {
    //     this.props.navigate('/promocodeAU', { state: { is_add: true, } })
    // }

    // handleUpdate(id) {
    //     this.props.navigate('/promocodeAU', { state: { is_update: true, promocodeID: id } })
    // }

    deleteprmocodeMaster(id) {
        console.log(id)
        this.setState({ isLoading: true })
        this.props.deletePromoCode_action(id)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    this.setState({ isLoading: false, deleteID: '' })
                    toastSuccess("deleted successfully")
                    setTimeout(() => {
                        this.getpromocodeMasterList()
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
                this.setState({ isOpen: false })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onDelete(i) {
        const { } = this.state
        this.setState({ deleteID: i })
        this.setState({ isOpen: true, })
    }

    onExhibitionChange(value) {
        const { exhibitionID } = this.state
        this.setState({ exhibitionID: value })
        this.getFillList(hallMasterListActionId, value, '', '', '', '');
    }

    updateItem(item) {
        const { promocodeList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = promocodeList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(promocodeList.length / recordsPerPage)
        this.setState({ startIndex: recordsPerPage * (item - 1) });
    }

    getPromocodeMasterDetails() {
        this.setState({ isLoading: true })
        const { isAUid } = this.state
        this.props.getPromoCodeDetails_action(isAUid)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data[0])
                    this.setState({ accountTypeIdAU: data.data[0].AccountTypeID })
                    this.setState({ exhibitionIDAU: data.data[0].ExhibitionID })
                    this.setState({ expiryAU: data.data[0].ExpiryDate })
                    this.setState({ NOCAU: data.data[0].NoofCoupens })
                    // this.setState({ CouponCodeAU: data.data[0].Code })
                    this.setState({ disPerAU: data.data[0].DiscountPercent })
                    // this.getFillList(accountTypeMasterListActionId, data.data[0][0].ExhibitionID, '', '', '', '');
                    this.setState({ isLoading: false })

                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // onPreviousClick() {
    //     this.props.navigate('/stallMasterList',)
    // }

    insertPromocodeMaster() {
        const { isLoading, exhibitionID, Utilization, exhibitionIDAU, accountTypeIdAU, disPerAU, expiryAU, NOCAU, CouponCodeAU, hallName, promocodeId, stallName, hallID, is_update, } = this.state
        // var finalList = [...stallList]
        var Err = false
        if (exhibitionIDAU == '' || exhibitionIDAU == null) {
            Err = true
        }
        if (accountTypeIdAU == '' || accountTypeIdAU == null) {
            Err = true
        }
        if (disPerAU == '' || disPerAU == null) {
            Err = true
        }
        if (expiryAU == '' || expiryAU == null) {
            Err = true
        }
        if (NOCAU == '' || NOCAU == null) {
            Err = true
        }
        if (Utilization == '' || Utilization == null) {
            Err = true
        }

        if (!Err) {
            if (disPerAU > 100 || disPerAU <= 0) {
                toastError('discount Percent should be less than 100')
            } else if (NOCAU <= 0) {
                toastError('Number of Coupons should be more than 0')
            } else {
                this.setState({ isLoading: true })
                this.props.insertPromoCode_action(exhibitionIDAU, accountTypeIdAU, disPerAU, expiryAU != null && expiryAU != '' ? moment(expiryAU).format('YYYY-MM-DD') : '', NOCAU, Utilization)
                    .then((data) => {
                        if (data.error != 1) {
                            console.log(data.data)
                            // this.props.navigate('/stallMasterList',)
                            toastSuccess("added successfully")
                            this.setState({
                                isAu: false, isAUid: '', exhibitionIDAU: '',
                                accountTypeIdAU: '',
                                // CouponCodeAU: '',
                                disPerAU: '',
                                expiryAU: '',
                                NOCAU: ''
                            })
                            this.getpromocodeMasterList()
                            this.setState({ isLoading: false })
                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
            // console.log(finalList)
        }
        else {
            toastError("Please enter mandatory fields")
        }
    }

    updatePromoCodeMaster() {
        const { isLoading, exhibitionID, exhibitionIDAU, accountTypeIdAU, disPerAU, expiryAU, NOCAU, CouponCodeAU, hallName, promocodeId, stallName, hallID, isAUid, is_update, } = this.state        // var finalList = [...stallList]
        // if (finalList.length == 0) {
        //     if (stallName != '' && stallName != '') {
        //         finalList.push({ stallName: stallName })
        //     }
        // }
        var Err = false
        if (exhibitionIDAU == '' || exhibitionIDAU == null) {
            Err = true
        }
        if (accountTypeIdAU == '' || accountTypeIdAU == null) {
            Err = true
        }
        if (disPerAU == '' || disPerAU == null) {
            Err = true
        }
        if (expiryAU == '' || expiryAU == null) {
            Err = true
        }
        if (NOCAU == '' || NOCAU == null) {
            Err = true
        }

        if (!Err) {
            if (disPerAU > 100 || disPerAU < 0) {
                toastError('discount Percent should be less than 100')
            } else {
                this.setState({ isLoading: true })
                this.props.updatePromoCode_action(exhibitionIDAU, accountTypeIdAU, disPerAU, expiryAU != null && expiryAU != '' ? moment(expiryAU).format('YYYY-MM-DD') : '', NOCAU, isAUid)
                    .then((data) => {
                        if (data.error != 1) {
                            console.log(data.data)
                            // this.props.navigate('/stallMasterList',)
                            toastSuccess("update successful")
                            this.setState({
                                isAu: false, isAUid: '', exhibitionIDAU: '',
                                accountTypeIdAU: '',
                                // CouponCodeAU: '',
                                disPerAU: '',
                                expiryAU: '',
                                NOCAU: ''
                            })
                            this.getpromocodeMasterList()

                            this.setState({ isLoading: false })
                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
        }
        else {
            toastError("Please enter mandatory fields")
        }
    }
    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    // onExpiryAUChange(e) {
    //     // e.preventDefault()
    //     const { visitDaysList } = this.state
    //     visitDaysList.map((data, i) => {
    //         if (ID == i) {
    //             data.toDate = (e)

    //     setTimeout(() => {
    //         console.log(visitDaysList)
    //         this.setState({ visitDaysList: visitDaysList })
    //     }, 200);
    // }

    render() {
        const { isOpen, isLoading, exhibitionID, currentPage, stallMasterList, stallName, hallID, hallMasterList, exhibitionList, hallName,
            promocodeList, accountTypeList, accountTypeId, CouponCode, disPer, expiry, status, NOC,
            accountTypeIdAU, disPerAU, expiryAU, statusAU, NOCAU, exhibitionIDAU, isAu, isAUid,deleteID
        } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = promocodeList.length > 0 ? promocodeList.slice(indexOfFirstRecord, indexOfLastRecord) : [];
        const nPages = Math.ceil(promocodeList.length / recordsPerPage)
        console.log(expiry, moment(expiry).format('YYYY-MM-DD'))
        console.log('deleteID',deleteID)
        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <AdminDrawer />
                    {!isAu ? <div className="main-container">
                        <div className="exb-topp">
                            {
                                JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                <div className="row m-2">
                                    {/* <div className="col-md-4">
                                        <label>Account Type</label>
                                        <select className="form-control"
                                            value={accountTypeId}
                                            onChange={(e) => this.onExhibitionChange(e.target.value)}  >
                                            <option value={''}>Select</option>
                                            {
                                                accountTypeList.length > 0 && accountTypeList.map(data => (
                                                    <option value={data.AccountTypeID} key={data.AccountTypeID}>{data.AccountTypeName}</option>
                                                ))
                                            }
                                        </select>
                                    </div> */}
                                    <div className="col-md-3">
                                        <label>Coupon Code</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={CouponCode}
                                            onChange={(e) => this.setState({ CouponCode: e.target.value, })}
                                        />
                                    </div>
                                    <div className="col-md-3 px-0">
                                        <label>Discount Percent</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            onInput={e => this.maxLengthCheck(e, 3)}
                                            size={3}
                                            value={disPer}
                                            maxLength={3}
                                            onChange={(e) => this.setState({ disPer: e.target.value, })}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Expiry Date</label>
                                        <DatePicker className="form-control"
                                            dateFormat="dd-MM-yyyy"
                                            minDate={new Date()}
                                            selected={expiry != '' && expiry != null ? new Date(expiry) : ''}
                                            onChange={(e) => this.setState({ expiry: e }, () => console.log(e, new Date(e)))}
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            placeholderText="dd-mm-yyyy"
                                        />
                                    </div>
                                    {/* <div className="col-md-3">
                                        <label>Status</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={status}
                                            onChange={(e) => this.setState({ status: e.target.value, })}
                                        />
                                    </div> */}

                                    {/* <div class="">
                                    <label for="validationCustom03">Total Exhibition Area<span style={{ color: 'red' }}>*</span></label>
                                    <input value={totalExhibitionArea} onChange={(e) => this.setState({ totalExhibitionArea: parseInt(e.target.value) })} type="number" class="form-control" placeholder="" />
                                </div> */}
                                </div>
                            }
                        </div>
                        < div className="row m-0  mt-2" >
                            <div className="col-md-12">
                                {
                                    JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                    <div
                                        className="mb-1"
                                        role="group"
                                        aria-label="Basic example"
                                        style={{ float: "right" }}
                                    >
                                        <button type="button" className="btn btn-aqua"
                                            onClick={e => this.getpromocodeMasterList()}
                                        >
                                            Search
                                        </button>
                                        <button type="button" className="btn btn-aqua mx-2"
                                            onClick={e => this.setState({
                                                isAu: true, isAUid: '',
                                            })}
                                        >
                                            Add
                                        </button>
                                        <button type="button" className="btn btn-gray"
                                            onClick={e => this.clearSearch()}
                                        >
                                            Clear
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="table-responsive  mt-2">
                            {this.record(currentRecords)}
                        </div>
                        <div className="mt-2 float">
                            {
                                promocodeList.length > 0 ?
                                    <Pagination
                                        nPages={nPages}
                                        currentPage={currentPage}
                                        setCurrentPage={this.updateItem}
                                    /> : <></>
                            }
                            <div className="tab-rec " style={{ float: "right" }}>
                                <p>{`${currentPage} of ${nPages} pages`}</p>
                            </div>
                        </div>
                    </div> :
                        <div className="main-container p-2">
                            <div className="row " style={{marginTop:'4rem'}}>
                                {
                                    JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                    <div className="row ">
                                        <div className="col-md-3">
                                            <label>Exhibition<span className="text-red">*</span></label>
                                            <select className="form-control"
                                                value={exhibitionIDAU}
                                                onChange={(e) => this.setState({
                                                    exhibitionIDAU: e.target.value
                                                })}  >
                                                <option value={''}>Select</option>
                                                {
                                                    exhibitionList.length > 0 && exhibitionList.map(data => (
                                                        <option value={data.ExhibitionID} key={data.ExhibitionID}>{data.ExhibitionName}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                        <div className="col-md-3">
                                            <label>Account Type<span className="text-red">*</span></label>
                                            <select className="form-control"
                                                value={accountTypeIdAU}
                                                onChange={(e) => this.setState({
                                                    accountTypeIdAU: e.target.value
                                                })}   >
                                                <option value={''}>Select</option>
                                                {
                                                    accountTypeList.length > 0 && accountTypeList.map(data => (
                                                        <option value={data.AccountTypeID} key={data.AccountTypeID}>{data.AccountTypeName}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                        <div className="col-md-3">
                                            <label>Discount Percent<span className="text-red">*</span></label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={disPerAU}
                                                onInput={e => this.maxLengthCheck(e, 3)}
                                                size={3}
                                                maxLength={3}
                                                onChange={(e) => this.setState({ disPerAU: e.target.value, })}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label>Expiry Date<span className="text-red">*</span></label>
                                            <DatePicker className="form-control"
                                                dateFormat="dd-MM-yyyy"
                                                selected={expiryAU != '' && expiryAU != null ? new Date(expiryAU) : ''}
                                                minDate={new Date()}
                                                onChange={(e) => this.setState({
                                                    expiryAU: e
                                                })}
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                placeholderText="dd-mm-yyyy"
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label>No of Coupons<span className="text-red">*</span></label>
                                            <input
                                                type="number"
                                                onInput={e => this.maxLengthCheck(e, 6)}
                                                size={6}
                                                maxLength={6}
                                                className="form-control"
                                                value={NOCAU}
                                                onChange={(e) => this.setState({ NOCAU: e.target.value, })}
                                            />
                                        </div>

                                        {/* <div class="">
                                    <label for="validationCustom03">Total Exhibition Area<span style={{ color: 'red' }}>*</span></label>
                                    <input value={totalExhibitionArea} onChange={(e) => this.setState({ totalExhibitionArea: parseInt(e.target.value) })} type="number" class="form-control" placeholder="" />
                                </div> */}
                                    </div>

                                }
                            </div>
                            {!(isAUid != '' && isAUid != null) && <div className="col-xl-3 mt-3">
                                <label>Coupons Utilization<span className="text-red">*</span></label>
                                <div className="row">
                                    {this.state.utilizationList.length > 0 && this.state.utilizationList.map(item => (
                                        <div className="col-xl-4">
                                            <label>
                                                <input type="radio" name="openSlides" value={this.state.Utilization}
                                                    checked={this.state.Utilization == item.ID}
                                                    onClick={e => this.setState({ Utilization: item.ID, })} /> {
                                                    item.Description
                                                }
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>}
                            < div className="row mt-2 mt-3" >
                                <div className="col-md-12">
                                    <div className="main-container container-fluid p-2 pt-0 pb-0">
                                        <div className="mt-1 mb-4">
                                            {
                                                sessionStorage.getItem("sessionExhRegistrationID") == null &&
                                                <button className="btn btn-previous" onClick={e => this.setState({
                                                    isAu: false, isAUid: '', exhibitionIDAU: '',
                                                    accountTypeIdAU: '',
                                                    // CouponCodeAU: '',
                                                    disPerAU: '',
                                                    expiryAU: '',
                                                    NOCAU: ''
                                                })}>
                                                    {" "}
                                                    Back{" "}
                                                </button>
                                            }

                                            <button className="btn btn-aqua mx-2" onClick={e => isAUid != '' && isAUid != null ? this.updatePromoCodeMaster() : this.insertPromocodeMaster()} >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                        <div className="modal-dialog" style={{ marginTop: '20%' }}>
                            <div className="modal-content confirm-logout">
                                <div class="modal-header text-right p-2">
                                    <h5 class="modal-title">Do you really want to delete this record?</h5>

                                    {/* <button type="button " class="close pop-close" data-dismiss="modal"
                                        onClick={() => this.setState({ isOpen: false })}
                                    ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                                </div>
                                {/* <div class="modal-body">
                                    <div class="row">
                                    </div>
                                </div> */}
                                <div class="modal-footer p-1">
                                    <div class="form-group text-right mod-fot">
                                        <button type="button" class="btn btn-del-pop"
                                            onClick={(e) => this.deleteprmocodeMaster(this.state.deleteID)}
                                        >Yes</button>
                                        <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                            onClick={() => this.setState({ isOpen: false, deleteID: '' })}
                                        >No</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Modal>
                    {/* <Footer /> */}
                </>
            </>)
    }

}
export default withRouter(connect(null, {
    fill_action, getPromoCodeList_action, deletePromoCode_action, insertPromoCode_action,
    updatePromoCode_action, getPromoCodeDetails_action
})(Exh_promoCode));